import React, { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import useApi from "../../../core/customhook/useApi";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";

const SelfBehaviouralCompetency = () => {
  const {financial_year} = useParams()
  const formatFinancialYear = (year: number) => {
    const nextYearShort = (year + 1).toString().slice(-2);
    return `${year}-${nextYearShort}`;
  };

  const getCurrentFinancialYear = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();
    const fyStart = month >= 3 ? year : year - 1;
    return formatFinancialYear(fyStart);
  };
  const [finance_year, setFinance_year] = useState(getCurrentFinancialYear());


  const [allItemList, setAllItemList] = useState<any[]>([]);



  const {
    data: viewgebehaviouralResponse,
    loading: viewgebehaviouralLoading,
    error: viewgebehaviouralError,
  } = useApi("/api/get-behavioural-competence", {
    method: "POST",
    payload: {
      financial_year: finance_year,
    },
    autoCall: true,
  });
  useEffect(() => {
    if (viewgebehaviouralResponse?.success) {
      setAllItemList(viewgebehaviouralResponse?.data);

    }
  }, [viewgebehaviouralResponse]);






  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Behavioral Competency</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Dashboard</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Behavioral Competency Setup
                  </li>
                </ol>
              </nav>
            </div>
            <div className="head-icons ms-2">
              <CollapseHeader />
            </div>
          </div>
          {allItemList?.length > 0 && (
            <div className="card">
              <div className="card-header">
                <h5>Saved Behavioral Competencies</h5>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-bordered table-hover">
                    <thead>
                      <tr>
                        <th>S No</th>
                        <th>Behavioral Competency</th>
                        <th>Description</th>
                        <th>Weightage (%)</th>
                        {/* <th>Financial Year</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {allItemList?.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.competency || "N/A"}</td>
                          <td>
                            <ul className="mb-0">
                              {item.description.map(
                                (desc: string, idx: number) => (
                                  <li>
                                    {"L" + (idx + 1)}&nbsp;&nbsp;
                                    {desc}
                                  </li>
                                )
                              )}
                            </ul>
                          </td>
                          <td>{item.weightage || "N/A"}%</td>
                          {/* <td>{item.financial_year || "N/A"}</td> */}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="d-flex justify-content-end mt-2">
                  <div className="d-flex gap-2">
                    <Link
                      to="/pms-kra-profile"
                      type="button"
                      className="btn btn-outline-secondary"
                    >
                      <i className="bi bi-arrow-left ms-2"></i>Back
                    </Link>
                    <Link
                      to={`/pms-career-aspirations/${financial_year}`}
                      type="button"
                      className="btn btn-secondary"
                    // onClick={clearCategoryId}
                    >
                      Next To Career Aspirations
                      <i className="bi bi-arrow-right ms-2"></i>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
          <p className="mb-0">
            © {new Date().getFullYear()} WeConnect. All rights reserved.
          </p>
        </div>
      </div>
    </>
  );
};

export default SelfBehaviouralCompetency;
